import React, { useRef, useState } from 'react';
import { Box, Grid, Link, TextField, Typography } from '@mui/material';
import Logo from '../../images/logo.png';
import useStore from '../../Store/Store';
import Button from '../../components/Button';

const Otp = ({ email, handleSubmitOtp, handleResendOtp, loader, errorMessage }) => {
  const [otp, setOtp] = useState(Array(6).fill(''));
  const inputRefs = useRef([]);
  const width = useStore((state) => state.screenWidth);

  const handleChange = (e, index) => {
    const { value } = e.target;
    if (/^[a-zA-Z0-9]$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (index < 5) {
        inputRefs.current[index + 1]?.focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace') {
      const newOtp = [...otp];
      if (otp[index]) {
        newOtp[index] = '';
      } else if (index > 0) {
        newOtp[index - 1] = '';
        inputRefs.current[index - 1]?.focus();
      }
      setOtp(newOtp);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: width > 1050 ? '50%' : '100%',
        padding: '1rem',
      }}
    >
      <Box
        component="img"
        sx={{ width: '55px', height: '37.56px', marginBottom: '2rem' }}
        alt="Mask group"
        src={Logo}
      />
      <div style={{ paddingInline: '4rem', paddingBlock: '12rem' }}>
        <Typography
          variant="h1"
          sx={{
            fontFamily: 'Inter, Helvetica',
            fontWeight: 'medium',
            fontSize: '40px',
            lineHeight: '48px',
          }}
        >
          Enter the code
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontFamily: 'Roboto, Helvetica',
            fontWeight: 'regular',
            fontSize: '16px',
            lineHeight: '24px',
            color: 'rgba(89, 89, 95, 1)',
            marginBlock: '30px',
          }}
        >
          We sent an otp to your email: {email || sessionStorage.getItem('email')}
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          <Typography
            variant="body2"
            sx={{
              fontFamily: 'Roboto, Helvetica',
              fontWeight: 'regular',
              fontSize: '12px',
              color: 'rgba(89, 89, 95, 1)',
            }}
          >
            Code
          </Typography>

          <Grid container spacing={2}>
            {otp.map((value, index) => (
              <Grid item xs key={index}>
                <TextField
                  inputRef={(ref) => (inputRefs.current[index] = ref)}
                  variant="outlined"
                  fullWidth
                  sx={{
                    borderColor: 'rgba(229, 229, 234, 1)',
                  }}
                  value={value}
                  onChange={(e) => handleChange(e, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  inputProps={{
                    maxLength: 1,
                    style: { textAlign: 'center' },
                  }}
                  size="small"
                />
              </Grid>
            ))}
          </Grid>
        </Box>

        <Button
          fullWidth
          onClick={() => handleSubmitOtp(otp)}
          loading={loader}
          text="Verify"
          style={{ marginTop: '20px' }}
        />

        <Typography
          variant="body1"
          sx={{
            fontFamily: 'Roboto, Helvetica',
            fontWeight: 'regular',
            fontSize: '16px',
            lineHeight: '24px',
            color: 'rgba(89, 89, 95, 1)',
          }}
        >
          <span>Didn&#39;t get the code?&nbsp;&nbsp;</span>
          <span
            style={{
              fontFamily: 'Roboto, Helvetica',
              fontWeight: 'medium',
              fontSize: '16px',
              lineHeight: '24px',
              color: 'rgba(0, 121, 107, 1)',
              cursor: 'pointer',
            }}
            onClick={() => handleResendOtp(email || sessionStorage.getItem('email'))}
          >
            Resend
          </span>
        </Typography>
      </div>
      <Typography variant="subtitle1" style={{ color: 'red', marginTop: '-100px' }} textAlign="center">
        {errorMessage}
      </Typography>
    </Box>
  );
};

export default Otp;
